import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { ResponseMessage } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { TimeSyncDefinition } from './time-sync-definition.model';

@Component({
  selector: 'app-time-sync-definition',
  templateUrl: './time-sync-definition.component.html',
  styleUrls: ['./time-sync-definition.component.scss']
})
export class TimeSyncDefinitionComponent extends AbstractWidgetComponent implements OnInit {

  isLoading = false;

  responseMessages: ResponseMessage[] = [];

  cancelEnabled = false;
  saveEnabled = false;

  detailsFormGroup = new FormGroup({});

  timeSyncDefinition = new TimeSyncDefinition({});

  constructor(
    public translationService: TranslationService,
    public httService: HttpService
  ) {

    super();

    this.detailsFormGroup.addControl('syncArrivalDate', new FormControl(null, []));
    this.detailsFormGroup.addControl('syncProcessingEnd', new FormControl(null, []));
    this.detailsFormGroup.addControl('syncStatusWaiting', new FormControl(null, []));
    this.detailsFormGroup.addControl('syncStatusProcessing', new FormControl(null, []));
    this.detailsFormGroup.addControl('syncStatusPaused', new FormControl(null, []));
    this.detailsFormGroup.addControl('syncStatusCancelled', new FormControl(null, []));
    this.detailsFormGroup.addControl('syncStatusFinished', new FormControl(null, []));

    this.detailsFormGroup.valueChanges.subscribe(
      v => {
        if (this.detailsFormGroup.dirty) {
          this.timeSyncDefinition.syncArrivalDate = this.detailsFormGroup.controls.syncArrivalDate.value;
          this.timeSyncDefinition.syncProcessingEnd = this.detailsFormGroup.controls.syncProcessingEnd.value;
          this.timeSyncDefinition.syncStatusWaiting = this.detailsFormGroup.controls.syncStatusWaiting.value;
          this.timeSyncDefinition.syncStatusProcessing = this.detailsFormGroup.controls.syncStatusProcessing.value;
          this.timeSyncDefinition.syncStatusPaused = this.detailsFormGroup.controls.syncStatusPaused.value;
          this.timeSyncDefinition.syncStatusCancelled = this.detailsFormGroup.controls.syncStatusCancelled.value;
          this.timeSyncDefinition.syncStatusFinished = this.detailsFormGroup.controls.syncStatusFinished.value;
          this.updateButtonEnablement();
        }
      }
    );

    this.loadSyncDefinition()
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) { }

  onSetElementAndContext() { }

  public cancel() {
    this.loadSyncDefinition();
  }

  public save() {
    this.isLoading = true;
    this.responseMessages = [];
    this.httService.postWithContext<ServiceResponse>(environment.timeSyncDefinitionEndpoint + '/save', this.timeSyncDefinition).pipe(
      map(d => new ServiceResponse(d))
    ).subscribe(
      response => {
        this.responseMessages = response.responseMessages;
        this.isLoading = false;
        this.loadSyncDefinition();
      }, error => {
        this.isLoading = false;
      }
    );
  }

  private loadSyncDefinition() {
    this.isLoading = true;
    this.responseMessages = [];
    this.httService.postWithContext<TimeSyncDefinition>(environment.timeSyncDefinitionEndpoint, {}).pipe(
      map(d => new TimeSyncDefinition(d))
    ).subscribe(
      result => {
        this.timeSyncDefinition = result;
        this.resetDetailsForm();
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
      }
    );
  }

  private resetDetailsForm() {
    const values: any = {};
    values.syncArrivalDate = this.timeSyncDefinition.syncArrivalDate;
    values.syncProcessingEnd = this.timeSyncDefinition.syncProcessingEnd;
    values.syncStatusWaiting = this.timeSyncDefinition.syncStatusWaiting;
    values.syncStatusProcessing = this.timeSyncDefinition.syncStatusProcessing;
    values.syncStatusPaused = this.timeSyncDefinition.syncStatusPaused;
    values.syncStatusCancelled = this.timeSyncDefinition.syncStatusCancelled;
    values.syncStatusFinished = this.timeSyncDefinition.syncStatusFinished;
    this.detailsFormGroup.reset(values);
    this.updateButtonEnablement();
  }

  updateButtonEnablement() {
    this.cancelEnabled = this.detailsFormGroup.dirty;
    this.saveEnabled = this.detailsFormGroup.dirty;
  }
}
